/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Label_UpperInputs */

const en_us2_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper`)
};

const pt_br2_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior`)
};

const es_419_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior`)
};

const pt_pt2_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superior`)
};

const fr_fr2_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut`)
};

const de_de2_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberkörper`)
};

const it_it2_plan_label_upper = /** @type {(inputs: Plan_Label_UpperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiore`)
};

/**
* | output |
* | --- |
* | "Upper" |
*
* @param {Plan_Label_UpperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_label_upper = /** @type {((inputs?: Plan_Label_UpperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Label_UpperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_label_upper(inputs)
	if (locale === "es-419") return es_419_plan_label_upper(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_label_upper(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_label_upper(inputs)
	if (locale === "de-DE") return de_de2_plan_label_upper(inputs)
	if (locale === "it-IT") return it_it2_plan_label_upper(inputs)
	return en_us2_plan_label_upper(inputs)
});
export { plan_label_upper as "plan.label_upper" }